<template>
  <div>
    <strong style="font-size: 18px">Customer Information</strong>
    <v-card flat class="text-xs-left mt-2" color="#EEEEEE">
      <v-card-text style="font-size: 15px">
        <span>
          Name : {{ order_detail.order_customer.customer_first_name }}
          {{ order_detail.order_customer.customer_last_name }}
          <span style="color: #ababab">|</span>
          {{ order_detail.order_customer.customer_country_tel
          }}{{ order_detail.order_customer.customer_tel }}
          <span style="color: #ababab">|</span>
          {{ order_detail.order_customer.customer_email }}
        </span>
      </v-card-text>
    </v-card>

    <v-list class="pb-0">
      <v-card flat color="grey lighten-3">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon>place</v-icon>Destination
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action style="position: absolute; right: 40px">
            <v-tooltip top>
              <v-icon
                slot="activator"
                :color="filterdCheckPoint ? 'green' : 'grey'"
                >{{ filterdCheckPoint ? "check_circle" : "schedule" }}</v-icon
              >
              <span>Status</span>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-tooltip top>
              <v-icon
                slot="activator"
                :color="filterdCheckPoint ? 'green' : 'grey'"
                @click="$emit('viewIMG', filterdImagePosition)"
                >image</v-icon
              >
              <span>View image</span>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>
      </v-card>
    </v-list>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-flex xs6 class="mr-2">
            <v-text-field
              v-if="!isFinalStatus"
              :disabled="disableInputs"
              v-model="
                order_detail.order_customer_address
                  .customer_address_contact_full_name
              "
              hide-details
              label="Place name"
            ></v-text-field>
            <div class="text-xs-left" v-if="isReadOnlyBlock">
              <label class="field-disable-title">Place name</label>
              <br />
              <div class="field-disable-data">
                {{
                  order_detail.order_customer_address
                    .customer_address_contact_full_name
                }}
              </div>
            </div>
          </v-flex>
          <v-flex xs6 class="ml-2">
            <div class="text-xs-left" v-if="isReadOnlyBlock">
              <label class="field-disable-title">Tel.</label>
              <br />
              <div class="field-disable-data">
                {{
                  order_detail.order_customer_address
                    .customer_address_contact_country_tel
                }}
                {{
                  order_detail.order_customer_address
                    .customer_address_contact_tel
                }}
              </div>
            </div>
            <v-layout row v-if="!isFinalStatus">
              <v-flex xs2>
                <v-select
                  :disabled="disableInputs"
                  :items="['+66']"
                  v-model="
                    order_detail.order_customer_address
                      .customer_address_contact_country_tel
                  "
                ></v-select>
              </v-flex>
              <v-flex xs10 class="ml-3">
                <v-text-field
                  :disabled="disableInputs"
                  v-model="
                    order_detail.order_customer_address
                      .customer_address_contact_tel
                  "
                  hide-details
                  label="Tel."
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-text-field
          :class="isReadOnlyBlock ? 'hidden-disable-long' : ''"
          :disabled="disableInputs"
          v-model="
            order_detail.order_customer_address.customer_address_information
          "
          hide-details
          label="Place detail"
        ></v-text-field>
        <v-text-field
          :class="isReadOnlyBlock ? 'hidden-disable-long mt-3' : 'mt-3'"
          :disabled="disableInputs"
          v-model="order_detail.order_customer_address.customer_address_text"
          hide-details
          label="Address"
        ></v-text-field>
        <v-layout row wrap justify-space-between class="mt-3">
          <v-flex xs6 class="pr-2">
            <div class="text-xs-left pt-1">
              <label class="field-disable-title">Latitude</label>
              <br />
              <div class="field-disable-data">
                {{ order_detail.order_customer_address.customer_address_lat }}
              </div>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <div class="text-xs-left pt-1">
              <label class="field-disable-title">Longitude</label>
              <br />
              <div class="field-disable-data">
                {{ order_detail.order_customer_address.customer_address_long }}
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <div class="text-xs-left pt-1">
              <label class="field-disable-title">Distance from store</label>
              <div class="field-disable-data">
                {{
                  order_detail.order_distance
                    ? order_detail.order_distance + " m."
                    : ""
                }}
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              v-if="!isFinalStatus"
              :disabled="disableInputs"
              name="note"
              hide-details
              v-model="
                order_detail.order_customer_address.customer_address_note
              "
              label="Place Note"
              value
              rows="2"
            ></v-textarea>
            <div class="text-xs-left pt-1" v-if="isReadOnlyBlock">
              <label class="field-disable-title">Place Note</label>
              <br />
              <div class="field-disable-data">
                {{ order_detail.order_customer_address.customer_address_note }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["order_detail", "loading"],
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
      province_list: (state) => state.fetchProvinceBack.province_list,
      district_list: (state) => state.fetchProvinceBack.district_list,
      sub_district_list: (state) => state.fetchProvinceBack.sub_district_list,
      zip_code_list: (state) => state.fetchProvinceBack.zip_code_list,
      customer_address_list: (state) =>
        state.fetchCustomerBack.customer_address_list,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    isFinalStatus() {
      return this.order_status_id == 6 || this.order_status_id == 7;
    },
    canOverride() {
      return this.$store.state.permission.order.edit_view == 3;
    },
    isReadOnlyBlock() {
      return (
        (this.isFinalStatus && !this.canOverride) ||
        this.$route.name == "OrderDetailFood"
      );
    },
    disableInputs() {
      return (this.isFinalStatus && !this.canOverride) || this.isEditOrder;
    },
    filterdImagePosition() {
      for (let val of this.order_detail.order_position) {
        if (
          val.position_contact_full_name ==
          this.order_detail.order_customer_address
            .customer_address_contact_full_name
        ) {
          return {
            img: val.position_image_check_point,
            place_name: "Destination",
          };
        }
      }
    },
    filterdCheckPoint() {
      for (let val of this.order_detail.order_position) {
        if (
          val.position_contact_full_name ==
          this.order_detail.order_customer_address
            .customer_address_contact_full_name
        ) {
          return val.position_order_status == 6;
        }
      }
    },
  },
  data() {
    return {
      select_address: ["address1", "address2"],
    };
  },
  methods: {
    selectCustomerAddress() {
      for (let val of this.customer_address_list) {
        if (
          this.order_detail.order_customer_address_id == val.customer_address_id
        ) {
          Object.assign(this.order_detail.order_customer_address, val);
        }
      }
      this.$emit("fetchAddress");
    },
    async onChangeDistrict(district_id) {
      await this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictList",
        district_id
      );
      await this.$store.dispatch(
        "fetchProvinceBack/getZipCodeList",
        district_id
      );
    },
    async onChangeProvince(province_id) {
      await this.$store.dispatch(
        "fetchProvinceBack/getDistrictList",
        province_id
      );
    },
  },
};
</script>

<style scoped>
.test {
  border-bottom: 15px solid green;
}
.hidden-disable {
  overflow: visible;
  padding: 0;
  border: none;
  text-align: center;
  margin-top: 24px;
}

.hidden-disable:after {
  content: ".";
  color: white;
  width: 100%;
  position: absolute;
  top: 29px;
  font-size: 5px;
  background: white;
}
.hidden-disable-long {
  overflow: visible;
  padding: 0;
  border: none;
  text-align: center;
  margin-top: 24px;
}

.hidden-disable-long:after {
  content: ".";
  color: white;
  width: 96%;
  position: absolute;
  top: 115px;
  font-size: 5px;
  background: white;
}
.field-disable-title {
  color: #9e9e9e;
  font-size: 12px;
}
.field-disable-data {
  color: #9e9e9e;
  font-size: 16px;
}
</style>